import { useState } from "react";
import { format, parseISO } from "date-fns";
import { de, bs, enGB } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const LOCALES = { de, bs, en: enGB };

export function DatePicker({ value, onChange, testid }) {
  const { i18n } = useTranslation();
  const loc = LOCALES[(i18n.language || "en").slice(0, 2)] || enGB;
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testid}
          className={cn("w-full justify-start font-normal", !value && "text-slate-400")}>
          <CalendarIcon className="mr-2 h-4 w-4 text-slate-400" />
          {value ? format(date, "dd MMM yyyy", { locale: loc }) : "—"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="z-[60] w-auto rounded-2xl border border-slate-200 p-0 shadow-xl shadow-navy/10" align="start" sideOffset={8}>
        <Calendar mode="single" selected={date} defaultMonth={date} locale={loc}
          captionLayout="dropdown-buttons" fromYear={1950} toYear={2040}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
